import { __assign, __rest } from "tslib";
import React from 'react';
import VeltRecordingPreviewStepsDialogCameraButtonOffWireframe from './VeltRecordingPreviewStepsDialogCameraButtonOffWireframe/VeltRecordingPreviewStepsDialogCameraButtonOffWireframe';
import VeltRecordingPreviewStepsDialogCameraButtonOnWireframe from './VeltRecordingPreviewStepsDialogCameraButtonOnWireframe/VeltRecordingPreviewStepsDialogCameraButtonOnWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecordingPreviewStepsDialogCameraButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-camera-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogCameraButtonWireframe.On = VeltRecordingPreviewStepsDialogCameraButtonOnWireframe;
VeltRecordingPreviewStepsDialogCameraButtonWireframe.Off = VeltRecordingPreviewStepsDialogCameraButtonOffWireframe;
export default VeltRecordingPreviewStepsDialogCameraButtonWireframe;
